import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { te } from 'date-fns/locale';

@Injectable({
    providedIn: 'root'
})
export class MailIntegrationApi {
    
        constructor(private http: HttpClient) { }
    dynamicMailPost(data: any) {

        if (data.Provider.toLowerCase() === "teleduce") {
            const httpOptions = {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                })
            };

            let apiUrlWithToken = `${data.isTemplate.emailUrl}/${data.isTemplate.emailApiKey}/${data.isTemplate.emailVersion}/`
            const body = {
                mail_datas: {
                    message: {
                        html_content: data.HtmlContact,
                        subject: data.Subject,
                        from_mail: data.isTemplate.emailSenderMail,
                        from_name: data.Branch?.name ?? data?.Branch,
                        reply_to: data.isTemplate.emailSenderMail,
                        to_recipients: [{
                            email_id: data.Patient.email,
                            name: `${data.Patient?.firstname}`
                        }],
                    },
                },
            };
            return this.http.post(apiUrlWithToken, body, httpOptions);

        }

    }
}